import React from "react";

const LeaderShip = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M10 34c0-2.238.89-4.385 2.473-5.968A8.447 8.447 0 0 1 26.89 34H10Zm8.444-9.494a6.33 6.33 0 1 1 0-12.66 6.33 6.33 0 1 1 0 12.66ZM12.741 11.846s2.278-2.21 5.863-2.15c3.586.058 5.497 1.992 5.497 1.992l2.788-6.924-5.685 1.418L18.639 2l-2.812 4.279L10 4.528l2.741 7.318Z"
            fill={fill}
        />
    </svg>
);

export default LeaderShip;
